import { useQuery } from '@apollo/client';
import { Heading, Paragraph, Stack, Text } from '@sixfold/common-ui';
import { useParams } from 'react-router';

import { CompanyDashboardsQuery, CompanyDashboardsQueryVariables } from '../../lib/graphql';
import { companyDashboardsQuery } from '../graphql';

export const CompanyDashboardsContainer = () => {
  const { company_id } = useParams() as { company_id: string };
  const { data, loading } = useQuery<CompanyDashboardsQuery, CompanyDashboardsQueryVariables>(companyDashboardsQuery, {
    variables: {
      company_id,
    },
  });

  if (loading) {
    return null;
  }

  return (
    <Stack direction="column">
      <Heading size="large">Lightdash</Heading>
      <Paragraph>
        The links below are valid for the <Text weight="bold">next 8 hours</Text> from the time of loading this view. To
        get new tokens refresh the page.
      </Paragraph>
      <ul>
        <li>
          <a href={data?.company?.lightdashEmbeddings.allocationSourceAndSuccessUrl} target="_blank" rel="noreferrer">
            Allocation source and success
          </a>
        </li>
      </ul>
    </Stack>
  );
};
